export default __webpack_public_path__ + "static/money-from-bracket-light.png";